document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.diamond-info-popup-content').forEach(content => {
    content.style.transform = 'translateX(0%)';
  });

  const toggleElements = document.querySelectorAll('.diamond-info-toggle');
  if (!toggleElements.length) return;

  toggleElements.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const popup = this.closest('.product-note-icon-text').querySelector('.diamond-info-popup');
      if (!popup) return;
      
      if (!popup.classList.contains('active')) {
        openPopup(popup);
      } else {
        closePopup(popup);
      }
    });
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('.diamond-info-popup-overlay')) {
      const activePopups = document.querySelectorAll('.diamond-info-popup.active');
      activePopups.forEach(popup => {
        closePopup(popup);
      });
    }
  });

  document.querySelectorAll('.diamond-info-popup-close').forEach(closeBtn => {
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      const popup = this.closest('.diamond-info-popup');
      if (popup) {
        closePopup(popup);
      }
    });
  });
    
  document.querySelectorAll('.diamond-info-popup-content').forEach(content => {
    content.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  function openPopup(popup) {
    const content = popup.querySelector('.diamond-info-popup-content');
    // Ensure starting position is set before animation
    content.style.transform = 'translateX(0%)';
    
    // Trigger reflow to ensure CSS applies
    void content.offsetWidth;
    
    popup.classList.add('active');
    popup.style.display = 'block';
    
    setTimeout(() => {
      content.style.transform = 'translateX(-100%)';
    }, 10);
  }

  function closePopup(popup) {
    const content = popup.querySelector('.diamond-info-popup-content');
    content.style.transform = 'translateX(0%)';
    
    setTimeout(() => {
      popup.classList.remove('active');
      popup.style.display = 'none';
    }, 300);
  }
});